export const INVOICE_STATUS_DISPLAY_MAPPINGS = {
    DRAFT: 'Draft',
    UNPAID: 'Not Paid',
    APPROVED: 'Approved',
    PROCESSING: 'Processing',
    PAID: 'Paid',
    CANCELLED: 'Cancelled',
    REVERTED: 'Reverted',
    VOIDED: 'Voided',
};

export const INVOICE_TYPE_DISPLAY_MAPPINGS = {
    RECEIVABLE: 'Receivable',
    PAYABLE: 'Payable',
    ONWARD_RECEIVABLE: 'Onward Receivable',
    ONWARD_PAYABLE: 'Onward Payable',
    INTERNAL: 'Internal',
};
